/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_CUSTOMER_FEE_URL, COMMON_HEADER_CONFIG} from "../config";

class CustomerFeeService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchCustomerFees = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_FEE_URL}/customer-fees`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCustomerFees = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_FEE_URL}/customer-fees`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createCustomerFee = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.platform_key = "centralweb";

      const config = {
        method: "post",
        url: `${API_CUSTOMER_FEE_URL}/customer-fee`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCustomerFee = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PATCH",
        url: `${API_CUSTOMER_FEE_URL}/customer-fee/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCustomerFeeById = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_FEE_URL}/customer-fee/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteCustomerFee = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_CUSTOMER_FEE_URL}/customer-fee/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const customerFeeService = new CustomerFeeService();

export default customerFeeService;
